module.exports = __webpack_public_path__ + "files/ca4e3b468e0d24ae948b162e83fc225d.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-600italic.eot
// module id = 455
// module chunks = 76